__turbopack_context__.v({
  "brainDivision": "how-it-works-module__wncYsG__brainDivision",
  "brainDrawing": "how-it-works-module__wncYsG__brainDrawing",
  "brainDrawingHidden": "how-it-works-module__wncYsG__brainDrawingHidden",
  "brainFold": "how-it-works-module__wncYsG__brainFold",
  "brainOutline": "how-it-works-module__wncYsG__brainOutline",
  "brainStem": "how-it-works-module__wncYsG__brainStem",
  "brainSvg": "how-it-works-module__wncYsG__brainSvg",
  "cardScan": "how-it-works-module__wncYsG__cardScan",
  "connector": "how-it-works-module__wncYsG__connector",
  "connectorActive": "how-it-works-module__wncYsG__connectorActive",
  "disclaimer": "how-it-works-module__wncYsG__disclaimer",
  "eyebrow": "how-it-works-module__wncYsG__eyebrow",
  "eyebrowDot": "how-it-works-module__wncYsG__eyebrowDot",
  "finalActions": "how-it-works-module__wncYsG__finalActions",
  "finalCta": "how-it-works-module__wncYsG__finalCta",
  "flowCard": "how-it-works-module__wncYsG__flowCard",
  "flowCardActive": "how-it-works-module__wncYsG__flowCardActive",
  "flowCardTop": "how-it-works-module__wncYsG__flowCardTop",
  "flowConclusion": "how-it-works-module__wncYsG__flowConclusion",
  "flowConclusionLine": "how-it-works-module__wncYsG__flowConclusionLine",
  "flowDescription": "how-it-works-module__wncYsG__flowDescription",
  "flowDetail": "how-it-works-module__wncYsG__flowDetail",
  "flowEyebrow": "how-it-works-module__wncYsG__flowEyebrow",
  "flowIcon": "how-it-works-module__wncYsG__flowIcon",
  "flowSection": "how-it-works-module__wncYsG__flowSection",
  "flowStatus": "how-it-works-module__wncYsG__flowStatus",
  "flowTrack": "how-it-works-module__wncYsG__flowTrack",
  "flowUnit": "how-it-works-module__wncYsG__flowUnit",
  "futureBadge": "how-it-works-module__wncYsG__futureBadge",
  "futureIntro": "how-it-works-module__wncYsG__futureIntro",
  "futureSection": "how-it-works-module__wncYsG__futureSection",
  "hero": "how-it-works-module__wncYsG__hero",
  "heroActions": "how-it-works-module__wncYsG__heroActions",
  "heroCopy": "how-it-works-module__wncYsG__heroCopy",
  "heroGlow": "how-it-works-module__wncYsG__heroGlow",
  "heroStats": "how-it-works-module__wncYsG__heroStats",
  "knowledgeIndex": "how-it-works-module__wncYsG__knowledgeIndex",
  "knowledgeItem": "how-it-works-module__wncYsG__knowledgeItem",
  "knowledgeItemActive": "how-it-works-module__wncYsG__knowledgeItemActive",
  "knowledgeList": "how-it-works-module__wncYsG__knowledgeList",
  "knowledgePanel": "how-it-works-module__wncYsG__knowledgePanel",
  "knowledgeText": "how-it-works-module__wncYsG__knowledgeText",
  "latticeLines": "how-it-works-module__wncYsG__latticeLines",
  "latticeLinesActive": "how-it-works-module__wncYsG__latticeLinesActive",
  "liveBadge": "how-it-works-module__wncYsG__liveBadge",
  "livePulse": "how-it-works-module__wncYsG__livePulse",
  "methodAnimated": "how-it-works-module__wncYsG__methodAnimated",
  "methodStatic": "how-it-works-module__wncYsG__methodStatic",
  "mindBody": "how-it-works-module__wncYsG__mindBody",
  "mindBodyKnowledgeCollapsed": "how-it-works-module__wncYsG__mindBodyKnowledgeCollapsed",
  "mindColumnLabel": "how-it-works-module__wncYsG__mindColumnLabel",
  "mindFrame": "how-it-works-module__wncYsG__mindFrame",
  "mindFrameFooter": "how-it-works-module__wncYsG__mindFrameFooter",
  "mindFrameInstant": "how-it-works-module__wncYsG__mindFrameInstant",
  "mindLineBreath": "how-it-works-module__wncYsG__mindLineBreath",
  "mindNode": "how-it-works-module__wncYsG__mindNode",
  "mindNodeActive": "how-it-works-module__wncYsG__mindNodeActive",
  "mindNodeCircle": "how-it-works-module__wncYsG__mindNodeCircle",
  "mindNodeFinal": "how-it-works-module__wncYsG__mindNodeFinal",
  "mindNodeFloat": "how-it-works-module__wncYsG__mindNodeFloat",
  "mindNodeHalo": "how-it-works-module__wncYsG__mindNodeHalo",
  "mindNodeHaloBreath": "how-it-works-module__wncYsG__mindNodeHaloBreath",
  "mindNodeLattice": "how-it-works-module__wncYsG__mindNodeLattice",
  "mindNodeValue": "how-it-works-module__wncYsG__mindNodeValue",
  "mindOrbit": "how-it-works-module__wncYsG__mindOrbit",
  "mindSection": "how-it-works-module__wncYsG__mindSection",
  "mindStatusText": "how-it-works-module__wncYsG__mindStatusText",
  "mindStatusTextActive": "how-it-works-module__wncYsG__mindStatusTextActive",
  "mindStatusTextPast": "how-it-works-module__wncYsG__mindStatusTextPast",
  "mindTransport": "how-it-works-module__wncYsG__mindTransport",
  "mindVisual": "how-it-works-module__wncYsG__mindVisual",
  "mindVisualFinal": "how-it-works-module__wncYsG__mindVisualFinal",
  "mindVisualLabel": "how-it-works-module__wncYsG__mindVisualLabel",
  "modelBridge": "how-it-works-module__wncYsG__modelBridge",
  "modelFacts": "how-it-works-module__wncYsG__modelFacts",
  "modelGauge": "how-it-works-module__wncYsG__modelGauge",
  "modelGaugeProgress": "how-it-works-module__wncYsG__modelGaugeProgress",
  "modelPanel": "how-it-works-module__wncYsG__modelPanel",
  "modelPanelActive": "how-it-works-module__wncYsG__modelPanelActive",
  "modelStatus": "how-it-works-module__wncYsG__modelStatus",
  "mono": "how-it-works-module__wncYsG__mono",
  "page": "how-it-works-module__wncYsG__page",
  "primaryButton": "how-it-works-module__wncYsG__primaryButton",
  "primaryLink": "how-it-works-module__wncYsG__primaryLink",
  "quantifyMark": "how-it-works-module__wncYsG__quantifyMark",
  "replayButton": "how-it-works-module__wncYsG__replayButton",
  "roadmapCard": "how-it-works-module__wncYsG__roadmapCard",
  "roadmapGrid": "how-it-works-module__wncYsG__roadmapGrid",
  "roadmapTop": "how-it-works-module__wncYsG__roadmapTop",
  "secondaryButton": "how-it-works-module__wncYsG__secondaryButton",
  "secondaryLink": "how-it-works-module__wncYsG__secondaryLink",
  "sectionHeading": "how-it-works-module__wncYsG__sectionHeading",
  "sectionIndex": "how-it-works-module__wncYsG__sectionIndex",
  "srStatus": "how-it-works-module__wncYsG__srStatus",
  "stepNumber": "how-it-works-module__wncYsG__stepNumber",
  "storyScene": "how-it-works-module__wncYsG__storyScene",
  "storySceneActive": "how-it-works-module__wncYsG__storySceneActive",
  "storyScenes": "how-it-works-module__wncYsG__storyScenes",
  "storyTitle": "how-it-works-module__wncYsG__storyTitle",
  "storyTitleActive": "how-it-works-module__wncYsG__storyTitleActive",
  "storyTitleLayer": "how-it-works-module__wncYsG__storyTitleLayer",
  "storyTitlePast": "how-it-works-module__wncYsG__storyTitlePast",
  "storyTransport": "how-it-works-module__wncYsG__storyTransport",
  "strategyBar": "how-it-works-module__wncYsG__strategyBar",
  "strategyBoard": "how-it-works-module__wncYsG__strategyBoard",
  "strategyBoardHeader": "how-it-works-module__wncYsG__strategyBoardHeader",
  "strategyCopy": "how-it-works-module__wncYsG__strategyCopy",
  "strategyList": "how-it-works-module__wncYsG__strategyList",
  "strategyRow": "how-it-works-module__wncYsG__strategyRow",
  "strategySection": "how-it-works-module__wncYsG__strategySection",
  "textLink": "how-it-works-module__wncYsG__textLink",
  "transportButton": "how-it-works-module__wncYsG__transportButton",
  "transportButtons": "how-it-works-module__wncYsG__transportButtons",
  "transportFill": "how-it-works-module__wncYsG__transportFill",
  "transportScrub": "how-it-works-module__wncYsG__transportScrub",
  "transportSpeed": "how-it-works-module__wncYsG__transportSpeed",
  "transportSpeedActive": "how-it-works-module__wncYsG__transportSpeedActive",
  "transportSpeeds": "how-it-works-module__wncYsG__transportSpeeds",
  "transportTime": "how-it-works-module__wncYsG__transportTime",
  "workflowCard": "how-it-works-module__wncYsG__workflowCard",
  "workflowGrid": "how-it-works-module__wncYsG__workflowGrid",
  "workflowHeader": "how-it-works-module__wncYsG__workflowHeader",
  "workflowIcon": "how-it-works-module__wncYsG__workflowIcon",
  "workflowLabel": "how-it-works-module__wncYsG__workflowLabel",
  "workflowLink": "how-it-works-module__wncYsG__workflowLink",
  "workflowNumber": "how-it-works-module__wncYsG__workflowNumber",
  "workflowSection": "how-it-works-module__wncYsG__workflowSection",
});
